import StatisticsFilter from './StatisticsFilterContainer';

export default StatisticsFilter;
